<template>
  <section id="MainSlider" class="home6-top">
    <div class="container">
      <div class="row q-col-gutter-md">
        <div v-if="slider" class="col-12 col-lg-8">
          <q-carousel ref="mainCarousel" animated v-model="slide" height="400px" autoplay transition-prev="slide-right" transition-next="slide-left" swipeable infinite>
            <q-carousel-slide :key="key" v-for="(slide, key) in slider.items" :name="key" :img-src="imageLink(slide.media)">
              <div class="main-slider--info absolute-bottom custom-caption">
                <div class="main-slider--actions">
                  <q-btn
                    v-if="slide.primarytext && slide.primarylink"
                    rounded
                    color="white"
                    text-color="dark"
                    class="text-weight-medium q-px-lg"
                    unelevated
                    no-caps
                    :target="`/${slide.primarylink}`"
                  >
                    <span class="action_btn_text"> {{ slide.primarytext }} </span>
                  </q-btn>
                </div>
                <!--                <div class="main-slider&#45;&#45;title">{{ slide.name }}</div>-->
                <!--                <div class="main-slider&#45;&#45;desc">{{ slide.desc }}</div>-->
              </div>
            </q-carousel-slide>

            <template v-slot:control>
              <q-carousel-control position="top-right" :offset="[18, 18]" class="q-gutter-xs">
                <q-btn
                  round
                  dense
                  color="dark"
                  unelevated
                  text-color="white"
                  icon="arrow_left"
                  aria-label="Slider Geri"
                  class="q-mr-sm"
                  @click="$refs.mainCarousel.previous()"
                />
                <q-btn round dense color="dark" unelevated text-color="white" icon="arrow_right" aria-label="Slider İleri" @click="$refs.mainCarousel.next()" />
              </q-carousel-control>
            </template>
          </q-carousel>
        </div>
        <div v-if="slider2" class="col-12 col-lg-4">
          <q-carousel
            animated
            v-model="slide2"
            height="400px"
            :autoplay="3500"
            transition-prev="slide-right"
            transition-next="slide-left"
            swipeable
            infinite
            navigation
            navigation-position="right"
          >
            <q-carousel-slide :key="key" v-for="(slide, key) in slider2.items" :name="key" :img-src="imageLink(slide.media)"></q-carousel-slide>
          </q-carousel>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'HomeSlider',

  setup() {
    const pageStore = PageStore();
    const { head, content } = storeToRefs(pageStore);

    // useMeta({
    //   title: `${content.value.categoryDetail} | ${head.value.title.siteTitle || 'Hazel Jewellery'}`,
    // });

    const slide = ref(0);
    const slide2 = ref(0);

    return {
      head,
      slide,
      slide2,
      slider: content.value.slider.mainSlider,
      slider2: content.value.slider.mainSubSlider,
    };
  },

  methods: {
    imageLink(img: string) {
      return this.head.title.siteAddress + '/images/' + img;
    },
  },

  mounted() {
    if (!this.slider) {
      console.error('Main Slider is not provided');
    }
    if (!this.slider2) {
      console.error('Main Sub Slider is not provided');
    }
  },
});
</script>

<style lang="sass" scoped>
.main-slider--info
  color: white

.main-slider--title
  font-size: 2rem
  font-weight: 300 !important

.custom-caption
  text-align: center
  padding: 12px
  color: white
  background-color: rgba(0, 0, 0, .3)

.main-slider--actions
  position: absolute
  right: 5%
  bottom: 220%

.action_btn_text
  font-size: .75rem
  letter-spacing: .07rem
  font-weight: 600
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif
</style>
